import React from 'react';
import { classnames } from '@/utils/classnames/classnames';
import Link from '@/components/atoms/link';
import { SidebarProps } from './types';
import { ArrowRightIcon } from '@heroicons/react/24/solid';

const Sidebar = ({ title, links = [] }: SidebarProps) => {

  const getSelectedTextCSS = (isActive: boolean | undefined) => {
    return !isActive ? 'text-[#909090]' : 'text-[#666666]';
  };
  return (
    // <div className="h-full bg-gray-100">
    //   <h6 className="px-5 text-12 font-medium uppercase text-gray-500">{title}</h6>
    //   <div className="mt-4 flex flex-col items-start gap-4">
    // {links.map(({ name, href, openInNewTab, isActive }) => (
    //   <Link
    //     key={href}
    //     className={classnames(
    //       'w-full rounded-lg px-5 py-2 text-14 font-medium text-gray-600 hover:bg-neutral-300',
    //       {
    //         'bg-neutral-300': isActive,
    //       },
    //     )}
    //     link={href ?? '#'}
    //     openInNewTab={openInNewTab}
    //     underlineOnHover={false}
    //   >
    //     {name}
    //   </Link>
    // ))}
    //   </div>
    // </div>

    <div className="mb-12">
      {/* <h6 className="px-5 text-12 font-medium uppercase text-gray-500">{title}</h6> */}
      <h6 className="px-5 text-12 font-medium uppercase text-gray-500">Tools</h6>
      <div className="mt-4 flex flex-col items-start gap-2">
        {links.map(({ name, href, openInNewTab, isActive }) => (
          <Link
            key={href}
            className={classnames(
              'mx-5 flex w-[87%] justify-between py-2 text-18 font-semibold leading-6 text-[#666666]',
              {
                'text-[#090909]': isActive,
              },
            )}
            link={href ?? '#'}
            openInNewTab={openInNewTab}
            underlineOnHover={false}
          >
            <div className="flex w-[100%]  border-b border-[#D1D1D1]  pb-5 whitespace-nowrap">
              <span className={getSelectedTextCSS(isActive)}>{name}</span>
              {isActive && <ArrowRightIcon width={20} className="ml-2 hidden text-[#090909] md:block" />}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
